var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(9236 -5983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    transform: "translate(-9236 5983)",
    fill: "none",
    stroke: "#15345a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(0 0.462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 24,
    height: 24,
    transform: "translate(-9228 5990.538)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(-9227.455 5991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M7.67,12A4.33,4.33,0,1,1,12,16.33,4.332,4.332,0,0,1,7.67,12Zm1.5,0A2.83,2.83,0,1,0,12,9.17,2.834,2.834,0,0,0,9.17,12Z",
    transform: "translate(-0.54 -0.462)",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M2.209,14.384a5.748,5.748,0,0,1,0-5.693C4.534,5.067,7.9,2.98,11.46,2.98S18.386,5.067,20.7,8.692a5.748,5.748,0,0,1,0,5.693C18.386,18.008,15.018,20.1,11.46,20.1S4.524,18.008,2.209,14.384Zm1.2-4.924a4.312,4.312,0,0,0,0,4.156c2.049,3.216,4.981,5.057,8.046,5.057s6-1.841,8.046-5.057a4.312,4.312,0,0,0,0-4.156C17.456,6.244,14.524,4.4,11.46,4.4S5.464,6.244,3.414,9.46Z",
    fill: "#15345a",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9e6eb7b3911d0d8b64651c45e4c26d3b.svg";
export { ForwardRef as ReactComponent };